module.exports = __webpack_public_path__ + "static/media/ze.d831327a.png";